<template v-if="popularBets">
    <CardComponent headline="Beliebteste Wetten" subheadline="">
        <div class="mb-3">Hier siehst du die beliebtesten Wetten (<i>quantitativ</i>, also unabhängig der eingespielten
            Spendensumme)</div>

        <template v-for="(popularBet) in popularBets" :key="popularBet.Key">
            <div class="d-flex justify-content-between">
                <span><b>{{ popularBet.Cnt }}x</b> {{ popularBet.BetName }}
                    <small v-if="popularBet.Match" class="text-muted">({{ formatMatch(popularBet.Match) }})</small>
                </span>
                <CountUpDecimal :targetValue="popularBet.TotalAmount" :animationTime=1000 class="text-success"
                    suffix="€" />
            </div>
            <hr v-if="popularBet !== popularBets.slice(-1)[0]" style="margin-top:6px;margin-bottom: 6px;" />
        </template>
    </CardComponent>
</template>
<span v-else>Lade Daten...</span>
<script>
import CountUpDecimal from './core/CountUpDecimal.vue';
import CardComponent from "../components/core/CardComponent.vue";
import { betGroupKey, formatMatch } from '../betMatch';
export default {
    name: 'PopularBets',
    props: {
        model: {
            type: Object,
            required: true,
        },
    },
    methods: { formatMatch },
    computed: {
        popularBets() {
            //exclude "Aufgerundet"
            const filteredBets = this.model.AllBets.filter(bet => bet.BetTypeId !== 4);

            // Gleiches Label bei verschiedenen Spielen sind verschiedene Wetten (siehe betMatch.js)
            const topBetGroups = Object.values(filteredBets.reduce((groups, bet) => {
                const key = betGroupKey(bet);
                groups[key] = groups[key] || [];
                groups[key].push(bet);
                return groups;
            }, {})).sort((a, b) => b.length - a.length).slice(0, 5);

            // Map group data to desired format
            const resultSet = topBetGroups.map(group => {
                const totalBetAmount = group.reduce((sum, bet) => sum + bet.TotalBetAmount, 0);
                return {
                    Key: betGroupKey(group[0]),
                    BetName: group[0].BetStr,
                    Match: group[0].Match,
                    Cnt: group.length,
                    TotalAmount: totalBetAmount,
                };
            });
            //console.log(resultSet);
            return resultSet;
        },

    },
    components: { CountUpDecimal, CardComponent }
};
</script>

<style scoped>
/* Add any styles you need here */
</style>